<template>
  <div>
    <div class="page-head">
      <div class="head-title">项目名称</div>
      <div class="head-detals">设计工作上最重要的是针对人们习以为常，认为理所当然的事物来做一些思考</div>
      <div class="head-author">
        <img class="head-img" alt="" src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />
        <div class="author-name">作者/公司名称</div>
      </div>
    </div>
    <div class="page__upload">
      <div class="page__upload_div">
        <!-- 上传文件 -->
        <div class="body__upload_center_div">
          <span class="body__upload_text" :lines="undefined">
            {{ body__upload_text }}
          </span>
          <div class="body__upload_file_div">
            <div class="upload_div">
              <a-upload
              name="file"
              :multiple="true"
              action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
              :headers="headers"
              @change="handleuploadChange"
              
            >
              <a-button> <a-icon type="upload" />上传文件</a-button>
            </a-upload>
            </div>
            
            <div class="upload-describe">
              用户点击按钮弹出文件选择框
            </div>
          </div>
        </div>
        <div class="body__label_box">
          <span class="body__label_text" :lines="undefined">
            {{ body__label_text }}
          </span>
          <span class="body__colon_text" :lines="undefined">
            {{ body__colon_text }}
          </span>
        </div>
        <!-- 选择 -->
        <div class="body__label_firstdiv">
          <a-select
            class="body__selects"
            mode="multiple"
            size="large"
            placeholder="请选择标签"
            @change="handleChange"
            @popupScroll="popupScroll"
            @filterOption="selectFilter"
            :options="labelList"
            optionFilterProp="children"
          >
          </a-select>
        </div>
        <div class="body__footer_div">
          <div class="body__footer_submit_div">
            <a-button type="danger" size="large">
              {{ body__footer_submit_text }}
            </a-button>
            <a-button style="margin:0 10px" size="large">
              保存
            </a-button>
            <a-button  size="large">
              删除
            </a-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      body__upload_text: "上传图片：",
      body__upload_file_text: "上传图片",
      body__upload_file_icon: require("@/assets/component/upload/img_32715_0_0.png"),
      body__file_select_text: "用户点击按钮弹出文件选择框",
      body__label_text: "标签",
      body__colon_text: "：",
      body__footer_submit_text: "提交",
      labelList: [
        {
          value: 1,
          label: "社交应用",
        },
        {
          value: 2,
          label: "游戏",
        },
      ],

      headers: {
        authorization: "authorization-text",
      },
    };
  },
  methods: {
    selectFilter(value, option) {
      console.log("filter", value, option);
    },
    handleChange(value) {
      console.log(`Selected: ${value}`);
    },
    popupScroll() {
      console.log("popupScroll");
    },
    handleuploadChange(info) {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }
      if (info.file.status === "done") {
        this.$message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        this.$message.error(`${info.file.name} file upload failed.`);
      }
    },
  },
};
</script>
<style lang="less" scoped>
@import "./index.response.css";
.page-head {
  box-sizing: border-box;
  padding: 32px 260px;
  background-color: #ffffff;
  text-align: start;
  }

.head-title {
  font-size: 20px;
  color: #333333;
  line-height: 24px;
}

.head-detals {
  font-size: 16px;
  color: #666666;
  text-align: justify;
  line-height: 22px;
  padding: 15px 0;
}

.head-author {
  display: flex;
}

.head-img {
  width: 25px;
  height: 25px;
}

.author-name {
  line-height: 30px;
  // display: flex;
  // align-items: center;
}

.upload_div {
  padding: 40px 20px ;
  // position: absolute;
  // top: 50%;
  // left: 50%;
  // transform: translate(-50%, -50%);
}
.body__selects {
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  width: 32.8vw;
  position: relative;
  bottom: 75px;
  border-radius: 0.21vw;
  background-color: #ffffff;
}

.upload-describe {
  border-top: 1px #e5e5e5 solid;
  width: 100%;
  padding: 30px 20px ;
}

/deep/ .ant-select-selection {
  width: 32.8vw;
}
/deep/ .body__footer_div .ant-btn > span {
  position: relative;
  top: 0.1vw;
}
</style>
